<template>
  <div>
    <h1>Política de Privacidade e Cookies</h1>

    <p>
      A OW Survey Offline App está comprometida a respeitar os direitos de privacidade dos
      usuários dos serviços disponibilizados, tanto pelo site como pelo aplicativo.
    </p>

    <p>
      Esta Política de Privacidade serve dar segurança aos usuários e descrever como são
      tratadas as suas informações pessoais disponibilizadas quando realizado acesso aos
      serviços da OW Survey Offline App.
    </p>

    <p>
      Esta Política de Privacidade aplica-se ao uso tanto das áreas públicas quanto das
      áreas restritas do site e do aplicativo.
    </p>

    <p>
      Ao escolher se tornar um membro cadastrado ou participar de nossas pesquisas, você
      aceita expressamente fornecer as informações descritas nesta Política de Privacidade
      para o uso do OW Survey Offline App na forma aqui definida.
    </p>

    <p>
      Quaisquer comentários ou dúvidas sobre a nossa Política de Privacidade ou sobre os
      dados coletados são bem-vindos.
    </p>

    <h2>Coleta de Informações Pessoais</h2>

    <p>
      Quando o Usuário acessa qualquer parte do site ou do aplicativo, são automaticamente
      coletadas determinadas informações enviadas pelo navegador de internet.
    </p>

    <p>
      Estas informações, doravante denominadas como “Informações de Arquivo de Log”, podem
      incluir os URLs que o Usuário visita; seu endereço de IP; data, hora, e horas gastas
      nas páginas visitadas, bem como informações sobre seu navegador e plataforma. Todas
      as informações referidas podem ser coletadas e utilizadas pela OW Survey Offline
      App. Também poderão ser coletadas outras informações como endereço de e-mail, nome
      de usuário, senha, e as respostas às pesquisas.
    </p>

    <p>
      As informações obtidas dos Usuários da OW Survey Offline App serão armazenadas
      apenas enquanto servirem a uma finalidade específica, seja pelo próprio cadastro dos
      seus Usuários, seja para formação de banco de dados, consulta e demonstração
      estatística.
    </p>

    <p>
      A seguir, para melhor detalhamento, divide-se as informações/dados por categoria:
    </p>

    <p>
      Informações de Registro: para utilização plena dos serviços disponibilizados pela OW
      Survey Offline App, e acesso às áreas restritas do site ou aplicativo (áreas
      disponíveis apenas para Usuários-membros), os usuários precisarão realizar cadastro
      no serviço, criando nome de usuário e senha, e fornecendo algumas informações
      pessoais limitadas, como endereço de e-mail e número de telefone (opcional).
    </p>

    <p>
      Para o cadastro também é solicitado o CPF (Cadastro de Pessoa Física) do Usuário,
      para fins de relatórios fiscais e individualização, especialmente em razão dos
      possíveis prêmios e recompensas pagos em valor superior a R$ 600,00 ao ano.
    </p>

    <p>
      Quando o usuário utiliza as áreas restritas do site, certas informações decorrentes
      do uso são automaticamente armazenadas, como atividades da conta (por exemplo:
      número de logins), dados exibidos ou clicados (por exemplo: elementos de interface
      dos usuários, elementos de interesse, links acessados), e outras informações de
      conexão.
    </p>

    <p>
      Os dados pessoais e específicos fornecidos pelos Usuários não serão disponibilizados
      a terceiros de forma possível a lhes identificar, publicados ou comercializados,
      exceto nas condições previstas nos “Termos de Uso” do site e/ou aplicativo, mediante
      prévia autorização, ou nas hipóteses previstas em lei.
    </p>

    <p>
      Os dados em questão, no entanto, poderão ser utilizados para categorizar as demais
      informações obtidas em pesquisas no site, como definição de faixa etária, sexo, etc.
    </p>

    <p>
      Respostas às pesquisas e outras formas de envio de informações: As pesquisas
      promovidas, conduzidas, ou simplesmente operadas pela OW Survey Offline App poderão
      prever o fornecimento de determinadas informações pessoais a respeito do perfil e
      histórico dos Usuários, podendo incluir CEP, idade, hábitos de consumo, hobbies,
      interesses, status profissional, localidades, produtos adquiridos (“perfil/histórico
      do usuário”).
    </p>

    <p>
      As informações obtidas poderão se referir aos interesses da própria OW Survey
      Offline App ou de seus clientes, que contratarem seus serviços para realização de
      pesquisa específica.
    </p>

    <p>
      A participação dos Usuários nas referidas pesquisas é totalmente voluntária e,
      portanto, cabe apenas a eles avaliarem previamente a conveniência de fornecer as
      informações solicitadas.
    </p>

    <p>
      Se o Usuário decidir participar de determinada pesquisa, pode ser solicitado o
      preenchimento de formulário preliminar no qual confirmado se o seu perfil está de
      acordo com o perfil traçado para o público da pesquisa. Neste caso, somente após a
      confirmação da compatibilidade de perfis a pesquisa poderá ser iniciada e obtidos os
      prêmios a ela relativos.
    </p>

    <p>
      As informações obtidas por meio de pesquisas ou dos demais serviços desenvolvidos
      pela OW Survey Offline App poderão ser utilizados pela empresa da forma como se
      fizer necessário ou conveniente, inclusive compartilhamento com terceiros
      interessados.
    </p>

    <p>
      A OW Survey Offline App torna-se proprietária dos dados lhe disponibilizados
      voluntariamente, de modo definitivo, mundial e irrevogável, isento de royalties e
      não exclusiva, transferível, podendo usar, reproduzir, criar trabalhos derivados,
      executar, exibir, transferir, transmitir, traduzir, distribuir e publicar qualquer
      ou todas as suas respostas, em qualquer mídia ou tecnologia atualmente ou
      futuramente conhecidos.
    </p>

    <p>
      Será dado o mesmo tratamento disposto neste tópico a informações voluntariamente
      apresentadas pelos Usuários mediante o preenchimento de formulários ou envio de
      e-mails ou cartas.
    </p>

    <p>
      Cookies e Outras Tecnologias de Informação: A OW Survey Offline App se resguarda ao
      direito de utilizar, quando julgar conveniente, os “Cookies” obtidos de seus
      usuários. Entende-se como “Cookies” porções de informações e dados armazenados pelos
      principais navegadores quando acessado e utilizado o OW Survey Offline App em
      qualquer plataforma. A OW Survey Offline App não insere quaisquer informações
      pessoais identificáveis nos Cookies.
    </p>

    <p>
      A OW Survey Offline App também pode utilizar outras formas de identificação online
      para monitorar o uso dos serviços disponibilizados, inclusive para identificar seus
      Usuários quando resolverem participar de determinadas pesquisas ou outras ofertas.
    </p>

    <p>
      Entre as tecnologias que podem ser utilizadas para obtenção de informações inclui-se
      “beacons”, identificadores de sessão de informação, ou outros meios semelhantes.
    </p>

    <p>
      Todas as tecnologias citadas servem para que a OW Survey Offline App possa melhorar
      os serviços prestados, reconhecer quando cada Usuário acessa o site ou aplicativo,
      coleta e análise de informações de modo estatístico, como por exemplo datas e horas
      de acesso, entre outros.
    </p>

    <p>
      Os Usuários poderão aceitar ou rejeitar o armazenamento de Cookies nas configurações
      de seu navegador.
    </p>

    <p>
      Se o Usuário optar pela inabilitação dos Cookies nas configurações do seu navegador,
      e não conseguindo a OW Survey Offline App armazenar as informações obtidas do
      Usuário ou se estas não puderem ser rastreadas, o Usuário não receberá os pontos e
      recompensas respectivos, e sua experiência com relação aos serviços desenvolvidos
      poderá ser significativamente diminuída.
    </p>

    <p>
      A OW Survey Offline App poderá oferecer aos Usuários a participação em pesquisas
      para as quais o cliente irá solicitar Cookies adicionais ou outras tecnologias da
      informação para estas pesquisas em particular. Nesta hipótese, a OW Survey Offline
      App informará sobre a necessidade de tecnologia adicional para determinada pesquisa,
      previamente à realização da pesquisa.
    </p>

    <h2>Utilização de Informação Pessoal</h2>

    <p>
      A OW Survey Offline App poderá utilizar livremente a informação pessoal
      identificável e informações agregadas/anônimas (conforme abaixo definido) coletadas
      dos seus Usuários, visto o seu objetivo-fim.
    </p>

    <p>
      Mais especificamente, as informações obtidas poderão ser utilizadas para: manter a
      conta do Usuário e manter o serviço disponível; enviar convites por e-mail ou
      mensagens de texto/SMS; encaminhar convites para a participação em pesquisas;
      verificar a adequação do Usuário ao público alvo de pesquisas específicas; entregar
      pontos e recompensas; disponibilizar informações sobre perfil/histórico do usuário;
      responder a informações dos clientes da OW Survey Offline App apenas de forma
      agregada/anônima; melhorar as ofertas da OW Survey Offline App; criar novas ofertas;
      quaisquer outros fins lícitos.
    </p>

    <p>
      Entende-se por informações “anônimas/agregadas” informações que são combinadas com
      aquelas de outros usuários e por tanto se tornam anônimas, ou que são transmitidas
      apenas com o perfil de interesse, dados demográficos e/ou resposta de um usuário em
      particular, sem que seja identificado especificamente o usuário.
    </p>

    <p>
      A OW Survey Offline App não envia “spam”. Os e-mails enviados após o registro do
      Usuário possuem como objetivo apenas convidá-lo ou alertá-lo para participar de
      novas pesquisas, enviar pontos e recompensas, enviar newsletters, para atualização e
      outros serviços ou notícias administrativas. O Usuário pode optar por não receber
      e-mails da OW Survey Offline App a qualquer momento, ainda que isso possa impedir o
      uso do serviço.
    </p>

    <p>
      Informações de Registro: A OW Survey Offline App não se utiliza das informações
      pessoais de seus Usuários para lhes enviar mensagens comerciais ou de marketing (nem
      tampouco ofertas referentes aos serviços prestados), sem que haja o seu
      consentimento prévio.
    </p>

    <p>
      A OW Survey Offline App poderá, entretanto, enviar comunicações relativas aos
      serviços prestados, cujo recebimento não poderá ser negado enquanto perdurar o
      registro na OW Survey Offline App, tais como informações referentes a pesquisas que
      se adequem ao perfil do membro. Caso o Usuário membro opte por não mais receber tais
      comunicações, o seu registro no site poderá ser cancelado.
    </p>

    <p>
      Informações sobre perfil/histórico usuário e respostas: No processo de registro e em
      outros momentos de utilização dos serviços, principalmente nas respostas às
      pesquisas, o Usuário disponibilizará informações sobre perfil/histórico. Tais
      informações serão utilizadas para direcionar pesquisas e interpretar melhor os
      resultados respectivos.
    </p>

    <p>
      Quando reportadas informações sobre endereço/histórico e informações de resposta aos
      clientes da OW Survey Offline App, isto sempre será feito de forma agregada/anônima.
    </p>

    <p>
      Informação do Arquivo de Log: Conforme já delimitado acima, a OW Survey Offline App
      pode utilizar Cookies, outras tecnologias de informação, e informações de arquivo de
      Log, para disponibilizar conteúdo personalizado e para administrar e monitorar a
      utilização dos serviços por seus usuários.
    </p>

    <p>
      Algumas pesquisas disponibilizadas serão conduzidas por meio das plataformas da
      própria OW Survey Offline App ou por meio de outras ferramentas crias ou utilizadas
      por seus clientes.
    </p>

    <p>
      Os clientes da OW Survey Offline App poderão solicitar um cookie específico ou outra
      tecnologia de informação quando o Usuário visitar o sistema deles para preencher a
      pesquisa.
    </p>

    <p>
      Enquanto o Usuário estiver interagindo com o site de um cliente, serão aplicadas as
      suas políticas de privacidades em relação ao uso do site. A OW Survey Offline App
      não é responsável por como seus clientes, ou qualquer terceiro, utilizarão as
      informações disponibilizadas enquanto o Usuário navegar ou acessar os sites
      respectivos.
    </p>

    <h3>Compartilhamento de Informações</h3>

    <p>
      A OW Survey Offline App não vende, aluga ou de qualquer maneira compartilha as
      informações identificáveis de seus Usuários com terceiros sem seu expresso
      consentimento.
    </p>

    <p>
      A OW Survey Offline App, no entanto, compartilha as informações obtidas de seus
      Usuários, não identificáveis, aos seus clientes de forma agregada/anônima, e
      exclusivamente para fins de pesquisa de mercado e levantamento estatístico.
    </p>

    <p>
      Mais precisamente, não se divulga a quaisquer terceiros informações que poderiam ser
      utilizadas para identificar os Usuários da OW Survey Offline App, mas sim
      informações coletadas nos serviços, sejam de registro, de pesquisas ou qualquer
      outro meio, por seu valor estatístico, demográfico e de individualização, mas sem
      capacidade de identificação.
    </p>

    <p>
      Para maior clareza, discrimina-se a seguir algumas formas pelas quais as informações
      dos Usuários dos serviços podem ser divulgadas, sempre no âmbito normal das
      atividades desenvolvidas: (a) cumprimento de leis, regulamentações, intimações e
      ordens judiciais; (b) desenvolvimento dos serviços por meio de subcontratados,
      resguardados por contrato de confidencialidade, da OW Survey Offline App; (c)
      proteção e defesa dos direitos de propriedade, incluindo investigações e defesa de
      ações judiciais de terceiros; (d) garantia do cumprimento dos contratos da OW Survey
      Offline App, Termos de Uso e Políticas; e/ou (e) proteção dos direitos, propriedade
      e segurança pessoal de dos Usuários, funcionários e o público.
    </p>

    <h2>Alterações na Conta</h2>

    <p>
      PO Usuário poderá alterar as configurações de sua conta editando seu perfil pessoal
      no aplicativo ou no site. As referidas alterações geralmente são efetuadas
      imediatamente, ou processadas em no máximo até 48 horas.
    </p>

    <p>
      De qualquer maneira, a OW Survey Offline App poderá reter qualquer informação, por
      qualquer tempo, até para sua proteção legal, ou simplesmente por estarem permitidas
      dentro da política de compartilhamento de informações da empresa, conforme descrito
      acima.
    </p>

    <h2>Opting Out</h2>

    <p>
      A OW Survey Offline App utiliza diversas ferramentas para melhor entender o
      comportamento de seus Usuários e sua forma de interação com os serviços
      desenvolvidos.
    </p>

    <p>
      Estas ferramentas informam à OW Survey Offline App as utilizações agregadas e o
      tráfico de informações, incluindo como o serviço foi acessado, quanto tempo os
      visitantes permaneceram no site ou aplicativo e o número de visitantes que
      utilizaram os serviços pela primeira vez.
    </p>

    <p>
      Ao saber como as pessoas utilizam os serviços, a OW Survey Offline App pode melhorar
      seu funcionamento. Na data de elaboração desta política de privacidade, a OW Survey
      Offline App utiliza o Google Analytics e o Hitslink para esta finalidade, o que pode
      ser alterado a qualquer tempo.
    </p>

    <p>
      Para entender melhor o Google Analytics e como ele utiliza seus dados, sugere-se
      visita ao site
      <a target="_blank" href="">http://www.google.com/analytics/learn/privacy.html</a>.
      Para entender melhor o Hitslink a como ele utiliza seus dados, sugere-se visita ao
      site <a target="_blank" href="">http://www.netapplications.com/privacy.aspx</a>.
    </p>

    <p>
      Os Usuários poderão se desligar dos serviços da OW Survey Offline App simplesmente
      clicando no link de cancelamento no rodapé de qualquer página do site ou no rodapé
      de qualquer e-mail que for enviado. O desligamento do Usuário será processado e
      concluído em até 48 horas do seu requerimento.
    </p>

    <h3>Links</h3>

    <p>
      O site e o aplicativo da OW Survey Offline App podem conter links que direcionam o
      usuário para outros sites controlados por terceiros. A OW Survey Offline App não se
      responsabiliza por qualquer conteúdo encontrado fora dos seus canais e plataformas
      oficiais, não sendo a empresa responsável pela política de privacidade ou conteúdo
      destes outros sites, cabendo ao usuário consultar as declarações de privacidade de
      cada site acessado, individualmente.
    </p>

    <h3>Segurança de Dados</h3>

    <p>
      A OW Survey Offline App recomenda que seus usuários mantenham seu nome de usuários e
      senha privados. A OW Survey Offline App não solicita senhas por meio de e-mails que
      não tenham sido encaminhados diretamente pelo sistema próprio de cadastramento
      inicial ou de recuperação de senha, ou por meio de telefonemas. Além disso,
      sugere-se que todos os Usuários se desconectem de sua conta do site ou aplicativo e
      fechem sua janela de navegação ou próprio aplicativo depois de completar uma
      pesquisa ou outra atividade no OW Survey Offline App. Isto irá proteger melhor a
      privacidade dos Usuários se houver compartilhamento de dispositivos ou acesso à
      internet de um computador em local público.
    </p>

    <h3>Alterações</h3>

    <p>
      A OW Survey Offline App poderá alterar esta Política de Privacidade a qualquer
      tempo, incluindo o uso de informações para fins novos e não antecipados em qualquer
      momento, disponibilizando uma versão revisada no site e aplicativo.
    </p>

    <p>
      Sempre que a Política de Privacidade for alterada, a nova versão será encaminhada
      por e-mail ou então deverá ser aprovada pelo usuário em seu próximo acesso aos
      serviços.
    </p>

    <p>
      A OW Survey Offline App considera que o Usuário aceitou as alterações realizadas
      caso mantenha a utilização dos serviços após as referidas alterações terem sido
      disponibilizadas.
    </p>

    <p>
      Se o Usuário não concordar com quaisquer das alterações realizadas, deverá
      imediatamente cessar o acesso e deixar de utilizar os serviços.
    </p>

    <h3>Solicitar remoção de dados</h3>

    <p>
      Você pode solicitar a remoção de seus dados diretamente entrando em contato com
      nossa equipe de suporte em support_owsurvey@offerwise.com. Dentro de 48 horas,
      removeremos todos os seus dados e enviaremos uma confirmação por e-mail.
    </p>

    <h3>Usuários Internacionais</h3>

    <p>
      Os serviços da OW Survey Offline App estão hospedados e são disponibilizados no
      Brasil. Usuários que acessarem os serviços de países da Europa, Ásia ou qualquer
      outra jurisdição com leis e regulamentos referentes à coleta, uso e divulgação de
      dados pessoais, que sejam diferentes das leis do Brasil e contrários ao aqui
      disposto, registra-se que, por meio do uso dos serviços Brasileiros, como este, as
      informações de seus dados pessoais são transferidas ao Brasil, ficando tacitamente
      aprovada esta transferência. A OW Survey Offline App não garante que qualquer
      serviço, ou qualquer parte dele é apropriado e disponível para uso em qualquer
      jurisdição que não a brasileira. Aqueles que escolherem acessar o serviço o fazem
      por iniciativa própria e assumem seu risco, e são responsáveis por cumprir com todas
      as leis locais, regras e regulamentações. A OW Survey Offline App poderá limitar a
      disponibilidade do serviço em todo ou em parte, para qualquer pessoa, área
      geográfica ou jurisdição que escolher, a qualquer momento e a nosso exclusivo
      critério.
    </p>

    <p>Data de Início da Vigência desta versão: 01 de abril de 2022.</p>
  </div>
</template>

<script>
export default {
  name: 'Portuguese',
}
</script>

<style lang="scss" scoped></style>
